<div class="model-content bg-secondary">
    <div class="madel-header ">
        <h3 mat-dialog-title class="model-title">Asset QR Entry</h3>
    </div>
    <div>
        <button class="close" mat-button (click)="onNoClick()">X</button>
    </div>
</div>
<div>
    <div class="p-2">
        <form class="example-form">
            <form>
                <div>
                    <div class="pt-3">
                        <div class="col-md-12">
                            <span class="image_format">Fusion Building Code</span>
                        </div>
                    </div>
                    <div class="pt-1">
                        <div class="col-md-12">
                            <div class="input-group">
                                <input type="text" #myInput class="form-control misinput_control" [(ngModel)]="searchorg">
                                <div>
                                    <button class="btn drop_iconsearch" type="submit" (click)="search(searchorg)">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pt-3">
                        <div class="col-md-12">
                            <span class="image_format">Building Name</span>
                        </div>
                    </div>
                    <div class="pt-1">
                        <div class="col-md-12">
                            <input class="form-control" type="text" placeholder="{{buildingName}}">
                        </div>
                    </div>



                    <div class="d-flex pt-3 gap-1">
                        <div class="col-md-6">
                            <span class="image_format">Po No</span>
                        </div>
                        <div class="col-md-6">
                            <span class="image_format">Major Category</span>
                        </div>
                    </div>
                    <div class="d-flex pt-1 gap-1">
                        <div class="col-md-6">
                            <input class="form-control" type="text" [(ngModel)]="poNo">
                        </div>

                        <div class="col-md-6">
                            <select name="" id="" class="drpdwn"  (change)="onSelectedMajor($event)">
                                <option value="">Select Major Category</option>
                                <option *ngFor="let data of majordetails" [value]="data.catMajorId">
                                    {{data.categoryName}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="d-flex pt-3 gap-1">
                        <div class="col-md-6">
                            <span class="image_format">Minor Category</span>
                        </div>
                        <div class="col-md-6">
                            <span class="image_format">Organization</span>
                        </div>
                    </div>
                    <div class="d-flex pt-1 gap-1">
                        <div class="col-md-6">

                            <select name="" id="" class="drpdwn" (change)="onSelectedMinor($event)">
                                <option value="">Select Minor Category</option>
                                <option *ngFor="let data of minorlist" [value]="data.catMinorId">
                                    {{data?.categoryName}}</option>
                            </select>

                        </div>
                        <div class="col-md-6">

                            <select name="" id="" class="drpdwn" (change)="onSelectedOrganization($event)">
                                <option value="">Select Organization</option>
                                <option *ngFor="let data of organizationlist" [value]="data.orgId">
                                    {{data.orgName}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="d-flex pt-3 gap-1">
                        <div class="col-md-6">
                            <span class="image_format">Block No</span>
                        </div>
                        <div class="col-md-6">
                            <span class="image_format">Block Name</span>
                        </div>
                    </div>

                    <div class="d-flex  pt-1 gap-1">
                        <div class="col-md-6">

                            <select name="" id="" class="drpdwn" (change)="onSelectedBlock($event)">
                                <option value="">Select Block No</option>
                                <option *ngFor="let data of blockNo" [value]="data">
                                    {{data}}</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <input class="form-control" #blockname type="text" [(ngModel)]="blockName">
                        </div>
                    </div>

                    <div class="d-flex pt-3 gap-1">
                        <div class="col-md-6">
                            <span class="image_format">Floor No</span>
                        </div>
                        <div class="col-md-6">
                            <span class="image_format">Room Type</span>
                        </div>
                    </div>

                    <div class="d-flex  pt-1 gap-1">
                        <div class="col-md-6">

                            <select name="" id="" class="drpdwn" (change)="onSelectedfloorNo($event)">
                                <option value="">Select Floor No</option>
                                <option *ngFor="let data of floorNo" [value]="data">
                                    {{data}}</option>
                            </select>
                        </div>
                        <div class="col-md-6">

                            <select name="" id="" class="drpdwn" (change)="onSelectedRoomtype($event)">
                                <option value="">Select Room Type</option>
                                <option *ngFor="let data of roomType" [value]="data">
                                    {{data}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="d-flex pt-3 gap-1">
                        <div class="col-md-6">
                            <span class="image_format">Room No</span>
                        </div>
                        <div class="col-md-6">
                            <span class="image_format">No of Assets</span>
                        </div>
                    </div>

                    <div class="d-flex  pt-1 gap-1">
                        <div class="col-md-6">
                            <input class="form-control" #roominput type="text" [(ngModel)]="roomNo">
                        </div>
                        <div class="col-md-6">
                            <input class="form-control" #noAsset type="text" [(ngModel)]="noAssets">
                        </div>
                    </div>
                </div>
            </form>
            <div class="col-lg-12 text-center pt-2">
                <button type="button" class="cctv_notebtn" (click)="onSubmit()">Submit</button>
            </div>
        </form>
    </div>
</div>

<!-- Loader -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>